<template>
    <section>
        <img v-if="loading_users || loading_requests" class="image page-loading" src="@/assets/img/page-loading.gif" />
        <div v-if="loading_users === false && loading_requests === false" class="mb-6">
            <h1 class="mb-5">Requests - Waiting for approval</h1>
            <table class="accounts mb-4">
                <tr>
                    <th></th>
                    <th>Firstname</th>
                    <th>Lastname</th>
                    <th>E-mail</th>
                    <th>Phone</th>
                    <th>Company</th>
                    <th>Website</th>
                </tr>
                <tr v-for="r in requests" :key="r.id" class="account">
                    <td>
                        <span v-on:click="approve_user(r.id)" class="approve-user"><svg viewBox="0 0 512 512"><path d="M362.6 192.9L345 174.8c-.7-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2l-122 122.9-44.4-44.4c-.8-.8-1.8-1.2-2.8-1.2-1 0-2 .4-2.8 1.2l-17.8 17.8c-1.6 1.6-1.6 4.1 0 5.7l56 56c3.6 3.6 8 5.7 11.7 5.7 5.3 0 9.9-3.9 11.6-5.5h.1l133.7-134.4c1.4-1.7 1.4-4.2-.1-5.7z"/></svg></span>
                        <span v-on:click="delete_user(r.id)" class="deny-user"><svg viewBox="0 0 512 512"><path d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"/></svg></span>
                    </td>
                    <td>{{ r.firstname }}</td>
                    <td>{{ r.lastname }}</td>
                    <td>{{ r.email }}</td>
                    <td>{{ r.phone }}</td>
                    <td>{{ r.company }}</td>
                    <td>{{ r.website }}</td>
                </tr>
            </table>
            <h1 class="mb-5 pt-6">Accounts</h1>
            <table class="accounts">
                <tr>
                    <th></th>
                    <th>Firstname</th>
                    <th>Lastname</th>
                    <th>E-mail</th>
                    <th>Phone</th>
                    <th>Company</th>
                    <th>Website</th>
                </tr>
                <tr v-for="u in users" :key="u.id" class="account">
                    <td>
                        <span v-if="u.is_admin" class="font-weight-bold">Admin</span>
                        <span v-if="u.is_admin == 0" v-on:click="delete_user(u.id)" class="delete-user mr-3"><svg viewBox="0 0 22.266 26.719"><path d="m98.227 87.757a2.974 2.974 0 0 0 2.969 2.962h11.874a2.974 2.974 0 0 0 2.969-2.962v-17.077h-17.812zm20.039-21.53h-5.566l-1.864-2.227h-7.406l-1.864 2.227h-5.566v2.227h22.266z" transform="translate(-96 -64)"/></svg></span>
                        <span
                            v-if="u.is_admin == 0"
                            v-on:click="get_user_permissions"
                            v-bind:data-user-id="u.id"
                            v-bind:data-title="u.firstname + ' ' + u.lastname"
                            class="user-permissions"
                        >
                            <svg viewBox="0 0 512 512"><path d="M416.3 256c0-21 13.1-38.9 31.7-46.1-4.9-20.5-13-39.7-23.7-57.1-6.4 2.8-13.2 4.3-20.1 4.3-12.6 0-25.2-4.8-34.9-14.4-14.9-14.9-18.2-36.8-10.2-55-17.3-10.7-36.6-18.8-57-23.7C295 82.5 277 95.7 256 95.7S217 82.5 209.9 64c-20.5 4.9-39.7 13-57.1 23.7 8.1 18.1 4.7 40.1-10.2 55-9.6 9.6-22.3 14.4-34.9 14.4-6.9 0-13.7-1.4-20.1-4.3C77 170.3 68.9 189.5 64 210c18.5 7.1 31.7 25 31.7 46.1 0 21-13.1 38.9-31.6 46.1 4.9 20.5 13 39.7 23.7 57.1 6.4-2.8 13.2-4.2 20-4.2 12.6 0 25.2 4.8 34.9 14.4 14.8 14.8 18.2 36.8 10.2 54.9 17.4 10.7 36.7 18.8 57.1 23.7 7.1-18.5 25-31.6 46-31.6s38.9 13.1 46 31.6c20.5-4.9 39.7-13 57.1-23.7-8-18.1-4.6-40 10.2-54.9 9.6-9.6 22.2-14.4 34.9-14.4 6.8 0 13.7 1.4 20 4.2 10.7-17.4 18.8-36.7 23.7-57.1-18.4-7.2-31.6-25.1-31.6-46.2zm-159.4 79.9c-44.3 0-80-35.9-80-80s35.7-80 80-80 80 35.9 80 80-35.7 80-80 80z"/></svg>
                        </span>
                    </td>
                    <td>{{ u.firstname }}</td>
                    <td>{{ u.lastname }}</td>
                    <td>{{ u.email }}</td>
                    <td>{{ u.phone }}</td>
                    <td>{{ u.company }}</td>
                    <td>{{ u.website }}</td>
                </tr>
            </table>
        </div>
        <!-- User Permissions Modal -->
        <b-modal v-bind:title="modal_user_permissions.title" id="user-permissions-modal" modal-class="message permissions-modal" hide-header-close ok-only ok-title="Close" centered>
            <b-form-group v-if="modal_user_permissions.folders_root.length > 0">
                <b-form-checkbox-group v-model="modal_user_permissions.folders_access" @input="update_user_permissions" name="user-permissions" switches>
                    <b-form-checkbox v-for="p in modal_user_permissions.folders_root" :key="p.id" v-bind:value="p.id">{{ p.name }}</b-form-checkbox>
                </b-form-checkbox-group>
            </b-form-group>
            <p v-if="modal_user_permissions.folders_root.length === 0" class="mb-0"><small>No folders is protected. To make a folder protected, click on the icon in the top left of each folder. When it's protected you will see it here and can give access to specific users.</small></p>
        </b-modal>
    </section>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'AccountAccounts',
        metaInfo: {
            title: 'Accounts'
        },
        data () {
            return {
                loading_users: false,
                loading_requests: false,
                users: null,
                requests: null,
                modal_user_permissions: {
                    title: null,
                    folders_root: [],
                    folders_access: []
                }
            }
        },
        mounted () {
            this.load_users();
            this.load_requests();
        },
        methods: {
            load_users () {
                this.loading_users = true;
                axios.get(process.env.VUE_APP_API_URL + '/api/users/')
                    .then(response => (
                        this.users = response.data,
                        this.loading_users = false
                    ))
            },
            load_requests () {
                this.loading_requests = true;
                axios.get(process.env.VUE_APP_API_URL + '/api/users/requests/')
                    .then(response => (
                        this.requests = response.data,
                        this.loading_requests = false
                    ))
            },
            approve_user: function (user_id) {
                axios.put(process.env.VUE_APP_API_URL + '/api/user/approve/', {
                    user_id: user_id
                })
                .then(response => (
                    this.load_users(),
                    this.load_requests()
                ))
            },
            delete_user: function (user_id) {
                if (confirm('Are you sure you want to delete the user?')) {
                    axios.delete(process.env.VUE_APP_API_URL + '/api/user/delete/', {
                        data: {user_id: user_id}
                    })
                    .then(response => (
                        this.load_users(),
                        this.load_requests()
                    ))
                }
            },
            get_user_permissions: function (event) {
                this.modal_user_permissions.folders_access = [];
                this.modal_user_permissions.user_id = event.currentTarget.getAttribute('data-user-id').toString();
                this.modal_user_permissions.title = event.currentTarget.getAttribute('data-title').toString() + ' - Protected folders';

                axios.get(process.env.VUE_APP_API_URL + '/api/user/permissions/' + this.modal_user_permissions.user_id)
                    .then((response) => {
                        this.modal_user_permissions.folders_root = response.data.folders_root;
                        this.modal_user_permissions.folders_access = response.data.folders_access;
                        this.$bvModal.show('user-permissions-modal');
                    });
            },
            update_user_permissions: function () {
                axios.put(process.env.VUE_APP_API_URL + '/api/user/permissions/', {
                    user_id: this.modal_user_permissions.user_id,
                    folders_access: JSON.stringify(this.modal_user_permissions.folders_access)
                })
            }
        }
    }
</script>
